import Reveal from "@/components/Reveal";

const foodImages = [
  "IMG_5500.webp", "IMG_5507.webp", "IMG_5515.webp", "IMG_5519.webp", "IMG_5521.webp",
  "IMG_5530.webp", "IMG_5531.webp", "IMG_5536.webp", "IMG_5542.webp", "IMG_5545.webp",
  "IMG_5546.webp", "IMG_5552.webp", "IMG_5558.webp", "IMG_5561.webp", "IMG_5565.webp",
  "IMG_5573.webp", "IMG_5577.webp", "IMG_5584.webp", "IMG_5586.webp", "IMG_5593.webp",
  "IMG_5594.webp", "IMG_5596.webp", "IMG_5599.webp", "IMG_5608.webp", "IMG_5610.webp",
  "IMG_5616.webp", "IMG_5617.webp", "IMG_5621.webp", "IMG_5624.webp", "IMG_5628.webp",
];

const rows = [0, 1].map((row) => foodImages.filter((_, index) => index % 2 === row));

export default function CulinaryTapestry() {
  return (
    <section className="editorial-section culinary-tapestry" id="food-gallery" aria-labelledby="tapestry-heading">
      <div className="section-inner">
        <Reveal>
          <div className="image-section-intro tapestry-intro">
            <div className="section-kicker">Visual tasting notes</div>
            <h2 className="image-section-title" id="tapestry-heading">A table in motion.</h2>
            <p className="image-section-description">A slow procession of texture, colour, and generous plates from the Hashtag kitchen.</p>
          </div>
        </Reveal>
      </div>
      <div className="food-river" data-testid="food-image-river">
        {rows.map((row, rowIndex) => {
          const loop = [...row, ...row];
          return (
            <div className={`food-row ${rowIndex === 1 ? "food-row--reverse" : ""}`} key={`food-row-${rowIndex + 1}`} data-testid={`food-image-row-${rowIndex + 1}`}>
              <div className="food-track">
                {loop.map((file, index) => (
                  <figure className="food-tile" key={`${file}-${index}`}>
                    <img src={`/assets/food-optimized/${file}`} alt={index < row.length ? "Hashtag food photography" : ""} aria-hidden={index >= row.length} loading="eager" decoding="async" data-testid={index < row.length ? `food-image-${rowIndex + 1}-${index + 1}` : undefined} />
                  </figure>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
